import React, { FC, useState } from "react";
import { object, string } from "yup";
import { useFormik } from "formik";
import DialogLayout from "../DialogLayout";
import Typography from "../../components/Typography/Typography";
import ASSETS from "../../assets";
import TextField from "../../components/TextField/TextField";
import Button from "../../components/Button/Button";

interface IProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onAddDomain?: (domain: string) => void;
}

const schema = object({
  domain: string()
    .required("Domain is required")
    .max(2000, "Domain cannot exceed 2000 characters")
   
});

const AddDomain: FC<IProps> = ({ open, setOpen, onAddDomain }) => {
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      domain: "",
    },
    validationSchema: schema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        if (onAddDomain) {
          await onAddDomain(values.domain);
        }
        handleClose();
      } catch (err: any) {
        console.log(err.message);
      } finally {
        setLoading(false);
      }
    },
  });

  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };

  return (
    <DialogLayout open={open}>
      <div className="w-full max-w-[536px] p-[25px] bg-white rounded-[15px] relative">
        <div
          className="absolute top-[25px] right-[25px] rounded-full size-[30px] bg-[#0000000D] cursor-pointer grid place-items-center"
          onClick={handleClose}
        >
          <img src={ASSETS.cross} alt="" />
        </div>
        <Typography variant="h2" className="font-bold title">
          Add New Domain
        </Typography>
        <Typography
          variant="body1"
          color="grey"
          className="mt-[5px] font-medium"
        >
          Add and Manage Your Domains        </Typography>
        <div className="border border-k-border rounded-lg p-6 mt-[25px] flex flex-col gap-6">
          <TextField
            label="Domain"
            name="domain"
            value={formik.values.domain}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.domain && formik.errors.domain
                ? formik.errors.domain
                : ""
            }
            onClear={() => formik.setFieldValue("domain", "")}
            required
          />

          <Button
            label="Add Domain"
            variant="primary"
            className="w-full h-[45px]"
            onClick={() => formik.handleSubmit()}
            loading={loading}
            type="button"
          />
        </div>
      </div>
    </DialogLayout>
  );
};

export default AddDomain;
